'use client';

import { RefObject, useCallback, useEffect, useRef } from 'react';

export function useBlurDetector(
	ref: RefObject<HTMLElement | null>,
	isOpen: boolean,
	closeDialog: () => void
) {
	const pausedRef = useRef(false);

	useEffect(() => {
		const field = ref.current;
		if (!field) return;

		const focusOutHandler = (event: FocusEvent) => {
			if (pausedRef.current || !isOpen || !ref.current) return;
			const next = event.relatedTarget as Node | null;
			if (!next || (!ref.current.isSameNode(next) && !ref.current.contains(next))) {
				closeDialog();
				if (next instanceof HTMLElement) next.focus();
			}
		};

		field.addEventListener('focusout', focusOutHandler);
		return () => field.removeEventListener('focusout', focusOutHandler);
	}, [ref, isOpen, closeDialog]);

	const pause = useCallback(() => {
		pausedRef.current = true;
	}, []);
	const resume = useCallback(() => {
		pausedRef.current = false;
	}, []);

	return { pause, resume };
}
